import { ISecurityLoginAction, ISecurityLogoutAction, ISecurityPayload, ISecurityUnauthAction, SecurityActionTypes } from './ActionTypes';

export function loginToken(param: ISecurityPayload): ISecurityLoginAction {
  return {
    type: SecurityActionTypes.LOGIN_USER,
    payload: {
      security: param
    }
  };
}

export function logoutUser(): ISecurityLogoutAction {
  return {
    type: SecurityActionTypes.LOGOUT_USER
  };
}

export function unauthUser(param: string): ISecurityUnauthAction {
  return {
    type: SecurityActionTypes.UNAUTH_USER,
    payload: {
      message: param
    }
  };
}
